import { Component } from '@opten/compiler/metadata/component';
import { wantsToBeGuestStorage } from '../shop/shop-context';
import dispatchCustomEvent from '@opten/events/dispatch-custom-event';

@Component({ className: 'js-wants-to-be-guest', observe: true })
export class WantsToBeGuestComponent {
	constructor(private element: HTMLElement) {
		element.addEventListener('click', e => {
			e.preventDefault();
			wantsToBeGuestStorage.set(true);
			dispatchCustomEvent(document.querySelector('#basket-sign-up-modal'), 'close');
		});
	}
}
